import React, { MouseEventHandler } from 'react'

import NFIcon from '@components/shared/NFIcon'

interface Props {
  error: string
  onClearError: MouseEventHandler<HTMLButtonElement>
}

const ErrorToast: React.FC<Props> = ({ error, onClearError }: Props) => {
  return (
    <div className="flex flex-row items-center justify-between px-4 py-2 mx-2 my-2 text-white rounded shadow-md bg-orange">
      <NFIcon icon="warning-sign" className="mr-3" />
      <span>{error}</span>
      <button
        type="button"
        className="flex flex-row items-center ml-5 opacity-75 hover:opacity-100"
        onClick={onClearError}>
        <i className="nf-icon nf-close text-md" />
      </button>
    </div>
  )
}

export default ErrorToast
